import { SxProps, Theme } from '@mui/material'

import { NAV_INPUT_BORDER, NAV_INPUT_LABEL } from '@/common/constants'

export const SELECTOR_BOX_SX: SxProps<Theme> = {
  px: 2.5,
  mt: 2,
  // The theme gives outlined fields a white fill; these two sit on the blue nav
  // drawer, where that would paint a white box.
  '& .MuiOutlinedInput-root': { backgroundColor: 'transparent' },
  '& .MuiInputBase-input': { color: 'common.white' },
  '& .MuiInputLabel-root': { color: NAV_INPUT_LABEL },
  '& .MuiInputLabel-root.Mui-focused': { color: 'common.white' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: NAV_INPUT_BORDER },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: NAV_INPUT_LABEL,
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'common.white',
  },
  '& .MuiSvgIcon-root': { color: 'common.white' },
}
